import { Grid } from '@mui/material'
import { useFormattedUserData } from '../../../hooks'
import {
  ROUTE_OWNINFO,
  ROUTE_OWNINFO_EMPLOYMENT,
  ROUTE_OWNINFO_MEMBERSHIP
} from '../../../routes'
import {
  MaybeEmploymentSummaryInfo,
  MaybeMembershipSummaryInfo
} from '../../../types'
import { MaybeString } from '../../../utils'
import { UserInfo } from '../../../utils/classes/graphql'
import { MainContentLinks } from './main-content-links'
import { MainContentNews } from './main-content-news'
import { MainContentSection } from './main-content-section'

interface MainContentProps {
  user: UserInfo
  employmentSummary: MaybeEmploymentSummaryInfo
  membershipSummary: MaybeMembershipSummaryInfo
  showNews: boolean
}

export const MainContent = ({
  user,
  employmentSummary,
  membershipSummary,
  showNews
}: MainContentProps) => {
  const {
    contactInfoList,
    userDepartment,
    userMemberNumber,
    userMemberShip,
    validEmployments,
    latestLogin,
    welcomeText
  } = useFormattedUserData(user, employmentSummary, membershipSummary)

  return (
    <Grid
      container
      spacing={{ xs: 0, md: 4 }}
      sx={{
        py: 3
      }}
    >
      <Grid item md={7} sm={12} xs={12}>
        <MainContentSection
          headerPrimary={welcomeText}
          headerSecondary={latestLogin}
          id="userInfo"
          sectionLinkProps={{
            route: ROUTE_OWNINFO,
            translationId: 'pages.frontPage.modifyUserInfo'
          }}
          sectionTextItems={contactInfoList.map(
            (contact: MaybeString, index: number) => {
              return {
                id: `contact-line-${index}`,
                lineText: contact
              }
            }
          )}
        />
        <MainContentSection
          headerPrimaryId="pages.frontPage.sections.membership.membershipHeader"
          id="membership"
          sectionLinkProps={{
            route: ROUTE_OWNINFO_MEMBERSHIP,
            translationId: 'pages.frontPage.open'
          }}
          sectionTextItems={[
            {
              id: 'membership-info-line',
              lineText: `${userMemberShip} ${userMemberNumber}`
            },
            { id: 'membership-department-line', lineText: `${userDepartment}` }
          ]}
        />
        <MainContentSection
          headerPrimaryId="pages.frontPage.sections.employment.employmentHeader"
          id="employment"
          noSectionItemsMessageId="pages.frontPage.sections.employment.noEmployment"
          sectionLinkProps={{
            route: ROUTE_OWNINFO_EMPLOYMENT,
            translationId: 'pages.frontPage.open'
          }}
          sectionTextItems={validEmployments.map(
            (employmentText: string, index: number) => {
              return {
                id: `employment-line-${index}`,
                lineText: employmentText
              }
            }
          )}
        />
      </Grid>
      <Grid item md={true} sm={12} xs={12}>
        {showNews && <MainContentNews />}
        <MainContentLinks />
      </Grid>
    </Grid>
  )
}
